import BaseButton from '@/components/BaseButton'
import Pager from '@/components/PagerComponent'
import { Modal } from 'bootstrap'

export default {

  components: {
    Pager,
    BaseButton
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      users: [],
      displayedUsers: [],
      error: false,
      responseErr: '',
      isProcessing: false,
      actionUser: null,
      confirmedAction: ''
    }
  },

  created () {
    if (this.$store.state.users.localeChanged) {
      this.$store.dispatch('users/setLocaleChanged', false)
      window.location.reload(true)
    }
    this.getUsers()
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    async getUsers () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('users/reset')
      await this.$store.dispatch('users/search', {
        idDistributeur: 'selectedDistributorRef'
      }).then(
        response => {
          this.users = response
          this.isProcessing = false
        },
        error => {
          this.users = []
          this.isProcessing = false
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    isLoggedUserAccount (userToCheck) {
      const loggedUser = JSON.parse(sessionStorage.getItem('user'))

      if (loggedUser.login == null) {
        return false
      }
      if (userToCheck.login == null) {
        return false
      }

      if (loggedUser.login === userToCheck.login) {
        return true
      }

      return false
    },

    isAccountLockedStatus (userToCheck) {
      var userStatus = userToCheck.userStatus

      if (userStatus === 'LOCK_ADMIN') {
        return true
      }
      if (userStatus === 'LOCK_CRED') {
        return true
      }
      if (userStatus === 'LOCK_OPT') {
        return true
      }
      if (userStatus === 'EXPIRED') {
        return true
      }

      return false
    },

    async editUser (user) {
      this.$store.dispatch('users/setUser', user)
      this.$router.push({ name: 'user-edit' })
    },

    async deleteUser () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/delete', {
        identification: this.actionUser.login
      }).then(
        () => {
          successMsg = this.$i18n.t('label.user.deleteUserMsg', [this.actionUser.login] )
          this.showSuccess(successMsg)
          this.users.splice(this.users.indexOf(this.actionUser), 1)
          this.isProcessing = false
          // this.$router.push({ name: 'user-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    async reinitPwd (user) {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/reinitPwd', {
        identification: user.login,
        email: user.email,
        idRole: user.ihmRoleRef
      }).then(
        () => {
          this.isProcessing = false
          successMsg = this.$i18n.t('label.user.reinitPwdMsg', [user.login] )
          this.showSuccess(successMsg)
        },
        error => {
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
          this.isProcessing = false
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    async lockUser () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/lockUser', {
        identification: this.actionUser.login
      }).then(
        response => {
          successMsg = this.$i18n.t('label.user.lockUserMsg', [this.actionUser.login] )
          this.showSuccess(successMsg)
          this.users[this.users.indexOf(this.actionUser)] = response.updatedUser
          this.isProcessing = false
          // this.$router.push({ name: 'user-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    async unlockUser () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/unlockUser', {
        identification: this.actionUser.login,
        userStatus: this.actionUser.userStatus
      }).then(
        response => {
          if (this.actionUser.userStatus === 'LOCK_CRED' || this.actionUser.userStatus === 'EXPIRED') {
            successMsg = this.$i18n.t('label.user.unlockUserResetPwdMsg', [this.actionUser.login] )
          }
          else {
            successMsg = this.$i18n.t('label.user.unlockUserMsg', [this.actionUser.login] )
          }
          this.showSuccess(successMsg)
          this.users[this.users.indexOf(this.actionUser)] = response.updatedUser
          this.isProcessing = false
          // this.$router.push({ name: 'user-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    async resetOTP () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/resetOtp', {
        identification: this.actionUser.login
      }).then(
        response => {
          successMsg = this.$i18n.t('label.user.resetOtpMsg', [this.actionUser.login] )
          this.showSuccess(successMsg)
          this.users[this.users.indexOf(this.actionUser)] = response.updatedUser
          this.isProcessing = false
          // this.$router.push({ name: 'user-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    showError (msg) {
      var errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t("error." + msg)
    },

    showSuccess (msg) {
      var successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    showConfirmation (user, calledAction) {
      this.actionUser = user
      this.confirmedAction = calledAction
      var confirmationModal = new Modal(document.getElementById('confirmationModal'))
      confirmationModal.show()
    },

    executeConfirmedAction () {
      this.confirmedAction()
    }

  }
}
